var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useComponent } from '../../../hooks/useComponent';
import Container from '../../common/Container';
import CTAsList from '../../common/CTAsList';
import SectionState from '../../common/SectionState';
import StepCard from './components/StepCard';
import ItemsHeader from './StepsHeader';
import { StepsShell, StepsContent, StepsList } from './styles';
const Steps = ({ entryId, componentType }) => {
    var _a;
    const theme = useTheme();
    const steps = useComponent(entryId, componentType);
    if (!steps)
        return null;
    const _b = (_a = steps === null || steps === void 0 ? void 0 : steps.fields) !== null && _a !== void 0 ? _a : {}, { title, description, bodyLong, components = [], CTAs, BottomCTAs, BottomCTAsAlignement, titleSize = 'large', tileDirection = 'column', showNumbering = true } = _b, componentProps = __rest(_b, ["title", "description", "bodyLong", "components", "CTAs", "BottomCTAs", "BottomCTAsAlignement", "titleSize", "tileDirection", "showNumbering"]);
    const containerProps = Object.assign({ cap: components.length <= 3 || tileDirection === 'row'
            ? theme.caps.big
            : theme.caps.normal }, componentProps);
    return (_jsx(SectionState, { children: _jsx(Container, Object.assign({}, containerProps, { children: _jsxs(StepsShell, { children: [_jsx(ItemsHeader, { direction: components.length <= 3 ? 'column' : 'row', titleLevel: titleSize === 'large' ? 2 : 3, maxWidth: components.length <= 3 ? 745 : 1128, title: title, body: description, bodyLong: bodyLong, CTAs: CTAs }), (components === null || components === void 0 ? void 0 : components.length) > 0 && (_jsx(StepsList, { "$direction": tileDirection === 'column' ? 'row' : 'column', children: components.map((component, index) => (_createElement(StepCard, Object.assign({}, component.fields, { stepNumber: showNumbering ? index + 1 : undefined, key: component.sys.id, isRow: tileDirection === 'row' })))) })), !!BottomCTAs && (_jsx(StepsContent, { "$justify": BottomCTAsAlignement === 'left'
                            ? 'flex-start'
                            : BottomCTAsAlignement === 'right'
                                ? 'flex-start'
                                : 'center', children: _jsx(CTAsList, { CTAs: BottomCTAs }) }))] }) })) }));
};
export default Steps;
